// import _ from 'lodash'
import vm from '../main'

const internals = {}

internals.addTrip = function(trip) {
  trip = (({
    driverId,
    deviceId,
    vehicleId,
    _id,
    routeName,
    scheduleDate,
    returnTrip,
    routeId,
    status,
    startSite,
    endSite,
    regionManager,
    scheduleTime,
    journeyManager
  }) => {
    return {
      driverId,
      deviceId,
      vehicleId,
      _id,
      routeName,
      scheduleDate,
      returnTrip,
      routeId,
      status,
      startSite,
      endSite,
      regionManager,
      scheduleTime,
      journeyManager
    }
  })(trip)

  return vm.$tripDataRepository
    .create(trip)
    .then(result => {
      trip = result.data
      return trip
    })
    .catch(error => {
      console.error('tripService.createTrip-error:\n', error)
      throw error
    })
}

internals.updateTrip = function(trip) {
 
  trip = Object.assign({}, trip)

  trip = (({
    driverId,
    deviceId,
    vehicleId,
    _id,
    routeName,
    scheduleDate,
    originReachedAt,
    startDate,
    destinationReachedAt,
    returnTrip,
    routeId,
    status,
    startSite,
    endSite,
    regionManager,
    scheduleTime,
    journeyManager,
    endDate
  }) => {
    return {
      driverId,
      deviceId,
      vehicleId,
      _id,
      routeName,
      scheduleDate,
      returnTrip,
      routeId,
      status,
      startSite,
      endSite,
      regionManager,
      scheduleTime,
      journeyManager,
      endDate,
      originReachedAt,
      startDate,
      destinationReachedAt
    }
  })(trip)

  return vm.$tripDataRepository
    .update(trip._id, trip)
    .then(result => {
      trip = result.data
      return trip
    })
    .catch(error => {
      console.error('tripUpdate.update-error:\n', error)
      throw error
    })
}

export default internals



// WEBPACK FOOTER //
// ./src/services/trip.service.js